// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"c4e28595","251":"95d133a2","258":"b3ba65fb","294":"77709a2f","730":"085699b6","780":"f053faaf","983":"58ed1dac"}[chunkId] + ".chunk.css";
};